// This file is autogenerated by build/build-error-serializer.js, do not edit
/* istanbul ignore file */

  'use strict'
  const { dependencies } = require('fast-json-stringify/lib/standalone')

  const { Serializer, Validator } = dependencies

  const serializerState = {"mode":"standalone"}
  const serializer = Serializer.restoreFromState(serializerState)

  const validator = null


  module.exports = function anonymous(validator,serializer
) {

    
  
    // #
    function anonymous0 (input) {
      const obj = (input && typeof input.toJSON === 'function')
    ? input.toJSON()
    : input
  
      
    let addComma = false
    let json = '{'
  
        if (obj["statusCode"] !== undefined) {
          !addComma && (addComma = true) || (json += ',')
          json += "\"statusCode\":"
          json += serializer.asNumber(obj["statusCode"])
        }
        
        if (obj["code"] !== undefined) {
          !addComma && (addComma = true) || (json += ',')
          json += "\"code\":"
          json += serializer.asString(obj["code"])
        }
        
        if (obj["error"] !== undefined) {
          !addComma && (addComma = true) || (json += ',')
          json += "\"error\":"
          json += serializer.asString(obj["error"])
        }
        
        if (obj["message"] !== undefined) {
          !addComma && (addComma = true) || (json += ',')
          json += "\"message\":"
          json += serializer.asString(obj["message"])
        }
        
  return json + '}'
  
    }
  
    const main = anonymous0
    return main
    
}(validator, serializer)
